import IconWithText, { IconWithTextProps } from './IconWithText'

export default IconWithText

export { IconWithText }
export type { IconWithTextProps }
